import { NakedFormSelect } from './naked-form-select';

export class Webforms {
  constructor() {
    this.init();
  }

  init() {
    const context = document.querySelector(
      '.site-wrap.interior-wrap #block-rush-theme-mainpagecontent'
    );
    if (context) {
      new NakedFormSelect({
        formElement: context,
        target: '.webform-submission-form select',
        singleSelectOptions: {
          isSingleSelect: true,
          hideSearch: true,
        },
      }).setUpNakedFormSelectDropdown({
        fullScreenMobile: false,
      });
    }

    $(context).on('click', '.print-button', function (e) {
      e.preventDefault();
      window.print();
    });
  }
}
